import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Login from './modules/authentication/pages/Login';
import Protected from './components/Protected';
import ForgotPassword from './modules/authentication/pages/ForgotPassword';
import AppLayout from './componentsv2/Layout/AppLayout';
import { paths } from 'configs/paths';

const { main } = paths;

const Router = () => (
  <BrowserRouter>
    <Switch>
      <Route path={main.dashboardV2} component={Protected(AppLayout)} />
      <Route path={main.dashboard} component={Protected(AppLayout)} />
      <Route path={main.forgotPassword} component={ForgotPassword} />
      <Route path={main.login} component={Login} />
    </Switch>
  </BrowserRouter>
);

export default Router;
